import React from 'react'

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"

const ButtonToggle = ({
    children,
    open = false,
    onToggle = () => {},
    style = {
        cursor: 'pointer',
        display: 'inline-block',
        transition: 'all 400ms ease-out',
        margin: 0,
        padding: 0,
        border: 'none',
        backgroundColor: '#FFF',
    },
    ...props
}) => {

    return (
        <button
            className="toggle"
            onClick={onToggle}
            style={style} >
            {open ? (
                <KeyboardArrowUpIcon className="pill_icon ml-1" />
            ) : (
                <KeyboardArrowDownIcon className="pill_icon ml-1" />
            )}
        </button>
    )
}

export default ButtonToggle